<template>
  <div id="app" ref="main">
    <!-- v-title data-title="中医幕课网" -->
    <navigation class="follow" />
    <router-view />
    <fortherecord />
  </div>
</template>
<script>
// @ is an alias to /src
import navigation from "@/components/navigation.vue";
import fortherecord from "@/components/Fortherecord.vue";
export default {
  name: "Home",
  data() {
    return {};
  },
  methods: {},
  components: {
    navigation,
    fortherecord,
  },
  watch: {},
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

#app {
  width: 100%;
  height: 100%;
  // padding-top:90px ;
  // overflow: auto;
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // color: #2c3e50;
}
// ::-webkit-scrollbar {
  // margin-right:100px ;

  // background: red;
  // display: none; /* Chrome Safari */
// }
// #nav {
//   padding: 30px;
//   a {
//     font-weight: bold;
//     color: #2c3e50;
//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
body,
html {
  width: 100vw;
  height: 100%;
  margin: 0;
  padding: 0;
  padding-top: 70px;

  // overflow: auto;
}

// #app {
//   // height: 100%;
//   // overflow: auto;
// }
.follow {
  position: fixed;
  // z-index: 999px;
  top: 0px;
}
</style>
